import types from "../actions";

const initialState = {};
let newChannels = {};
export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_ALL_CHANNELS_SUCCESS:
      const allChannels = {};
      Object.values(action.payload).forEach(channels => {
        channels.forEach(channel => {
          allChannels[channel.id] = state[channel.id] && state[channel.id].tracks ? { ...channel, tracks: state[channel.id].tracks } : channel
        });
      })
      return allChannels
    case types.DELETE_CHANNEL_REQUEST:
      return { ...state, [action.id]: { ...state[action.id], wait: true } }
    case types.DELETE_CHANNEL_FAILURE:
      return { ...state, [action.id]: { ...state[action.id], wait: false } }
    case types.DELETE_CHANNEL_SUCCESS:
      newChannels = { ...state };
      delete newChannels[action.id];
      return newChannels;
    case types.GET_CHANNEL_SUCCESS:
      newChannels = { ...state };
      newChannels[action.channel.id] = action.channel;
      return newChannels;
    default:
      return state;
  }
}
